import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  font-size: 3.2em;

  /* tada */
  @keyframes tada {
    from {
      transform: scale3d(1, 1, 1);
    }

    10%,
    20% {
      transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
    }

    30%,
    50%,
    70%,
    90% {
      transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
    }

    40%,
    60%,
    80% {
      transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
    }

    to {
      transform: scale3d(1, 1, 1);
    }
  }

  .tada {
    animation-name: tada;
  }

  /* jack in the box */
  @keyframes jackInTheBox {
    from {
      opacity: 0;
      transform: scale(0.1) rotate(30deg);
      transform-origin: center bottom;
    }

    50% {
      transform: rotate(-10deg);
    }

    70% {
      transform: rotate(3deg);
    }

    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  .jackInTheBox {
    animation-name: jackInTheBox;
  }

  /* roll in */
  @keyframes rollIn {
    from {
      opacity: 0;
      transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .rollIn {
    animation-name: rollIn;
  }

  /* fade in down */
  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInDown {
    animation-name: fadeInDown;
  }

  .animated {
    animation-duration: 0.7s;
    animation-fill-mode: both;
  }

  .animated.delay {
    animation-delay: 0.1s;
  }

  .animatedTwo {
    animation-duration: 0.2s;
    animation-fill-mode: both;
  }
`;

export { Wrapper as default };
